import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { CleanupTenantCommandHandler } from './cleanup-tenant-command-handler.service';
import { PrintGdprCommandHandler } from './print-gdpr-command-handler.service';
import { SendRegistrationKeyCommandHandler } from './send-registration-key-command-handler.service';
import { ShowInvoicesCommandHandler } from './show-invoices-command-handler.service';
import { TenantCommandHandlerResolverBase } from './tenant-command-handler-resolver.base';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { RepayBalanceCommandHandler } from './repay-balance-command-handler.service';
import { ShowFaultNotificationCommandHandler } from './show-fault-notification-command-handler.service';
import { MoveBalanceCommandHandler } from './move-balance-command-handler.service';
import { tenantCommand } from '../../model/const/command';
import { ContactExportCommandHandler } from './contact-export-command-handler.service';

@Injectable()
export class TenantFormCommandHandlerResolver extends TenantCommandHandlerResolverBase {
  constructor(
    createHandler: CreateCommandHandler,
    cleanupHandler: CleanupTenantCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    gdprHandler: PrintGdprCommandHandler,
    sendKeyHandler: SendRegistrationKeyCommandHandler,
    showInvoiceHandler: ShowInvoicesCommandHandler,
    repayBalanceHandler: RepayBalanceCommandHandler,
    moveBalanceHandler: MoveBalanceCommandHandler,
    showFaultNotificationHandler: ShowFaultNotificationCommandHandler,
    exportHandler: ContactExportCommandHandler
  ) {
    super(
      cleanupHandler,
      gdprHandler,
      sendKeyHandler,
      showInvoiceHandler,
      repayBalanceHandler,
      showFaultNotificationHandler,
      exportHandler
    );
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(tenantCommand.moveBalance, moveBalanceHandler);
  }
}
